/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable prefer-template */

import React, { FormEvent, ReactElement, useEffect, useState } from 'react';
import ImagePath from 'app/utilities/imagePath';
import './WithdrawModal.scss';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import Toggle from 'react-toggle';
import LocalStorageService from 'app/services/localStorage';
import ROUTER_PATH from 'app/routes/routerPath';
import { RootState } from 'app/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import {
	withdrawForm,
	passwordForm,
	bankAccountTextLabel,
	minimumWithdrawAmount,
} from 'app/configs/withdrawForm.config';
import {
	ISubmitWithdrawPayload,
	submitWithdrawAction,
	resetWithdrawErrorStateAction,
	getWithdrawFeeAction,
	GetWithdrawFeePayload,
	setWithdrawFee,
} from 'app/redux/actions/WithdrawAction';
import { useNavigate } from 'react-router-dom';
import { IModalProps } from '../../interfaces/modalProps.interface';
import TextLabel from '../TextLabel/TextLabel';
import InputComponent from '../InputComponent/InputComponent';
import Button from '../Button/Button';
import ShimmeringLoading from '../ShimmeringLoading/ShimmeringLoading';

const WithdrawModal = function init(props: IModalProps): React.ReactElement {
	const { setOpenModal } = props;
	const portofolioState = useSelector(
		(state: RootState) => state.portofolioReducer
	);
	const withdrawState = useSelector(
		(state: RootState) => state.withdrawReducer
	);
	const { lenderSummary, summaryLoading } = portofolioState;
	const { withdrawLoading, error, successOnWithdraw, errorOnWithdraw } =
		withdrawState;
	const [form, setForm] = useState(withdrawForm);
	const [authForm, setAuthForm] = useState(passwordForm);
	const [isAuthForm, showAuthForm] = useState(false);
	const [invalid, setInvalid] = useState(true);
	const [invalidAmount, setInvalidAmount] = useState(true);
	const [invalidPassword, setInvalidPassword] = useState(true);
	const [isFullWithdraw, setFullWithdraw] = useState(false);
	const [bankAccountLabel] = useState(bankAccountTextLabel);
	const user = LocalStorageService.getUserData();
	const [amountWithdraw, setAmountWithdraw] = useState(0);

	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		bankAccountLabel[0].value =
			LocalStorageService.getUserData().bankInformation.bankAccountPayroll;
		bankAccountLabel[1].value =
			LocalStorageService.getUserData().bankInformation.bankAccount;
	}, []);

	useEffect(() => {
		if (successOnWithdraw || errorOnWithdraw) {
			resetFormField();
			navigate(ROUTER_PATH.afterWithdrawPage);
		}
	}, [successOnWithdraw, errorOnWithdraw]);

	useEffect(() => {
		isFormValid();
	}, [form]);

	useEffect(() => {
		if (error) {
			const tempAuthForm = [...authForm];
			tempAuthForm[0].apiErrorMessage = error || '';
			setAuthForm(tempAuthForm);
			setInvalidPassword(true);
		}
	}, [error]);

	function thousandSeparator(val: number): string {
		const res = val.toString().replace(/[^0-9]/g, '');
		return res.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	}

	function resetFormField(): void {
		const tempForm = [...form];
		const tempAuthForm = [...authForm];
		tempForm.forEach((field) => {
			field.apiErrorMessage = '';
			field.value = '';
		});
		tempAuthForm.forEach((field) => {
			field.apiErrorMessage = '';
			field.value = '';
		});
		dispatch(setWithdrawFee({ transfer_fee: 0, transfer_type: '' }));
		setForm(tempForm);
		setAuthForm(authForm);
	}

	function closeModal(): void {
		resetFormField();
		setFullWithdraw(false);
		showAuthForm(false);
		setOpenModal(false);
	}

	function isFormValid(): void {
		const isValid = !invalidAmount && form[3].value !== '';
		setInvalid(!isValid);
	}

	function onToggleChange(checked: boolean): void {
		const tempForm = [...form];
		const withdrawInput = tempForm[0];
		const fundsReceived = tempForm[2];
		if (checked) {
			withdrawInput.value = thousandSeparator(lenderSummary.cashBalance);
			if (lenderSummary.cashBalance >= minimumWithdrawAmount) {
				setAmountWithdraw(Number(lenderSummary.cashBalance));
				withdrawInput.disabled = true;
				const payload: GetWithdrawFeePayload = {
					amount: Number(lenderSummary.cashBalance),
					bankCode: user.bankInformation.bankCode,
					payment_method: user.bankInformation.methodPayment,
				};
				dispatch(getWithdrawFeeAction(payload));
				setInvalidAmount(false);
			} else {
				withdrawInput.apiErrorMessage = `Minimum jumlah penarikan dana adalah ${rupiahCurrencyFormatter(
					minimumWithdrawAmount
				)}`;
				setInvalidAmount(true);
			}
			setForm(tempForm);
		} else {
			withdrawInput.disabled = false;
			withdrawInput.value = '';
			fundsReceived.value = '';
			setInvalidAmount(true);
			setForm(tempForm);
		}
		setFullWithdraw(checked);
	}

	function onChangeHandle(event: Record<string, string>): void {
		const fieldForm = form.find((field) => field.name === event.name);
		const val = event.value.split('.').join('');
		if (fieldForm?.id === 'withdrawAmount') {
			fieldForm.value = event.value;
			if (val.length) {
				if (Number(val) > lenderSummary.cashBalance) {
					fieldForm.apiErrorMessage = `Jumlah penarikan melebihi saldo yang tersedia`;
					setInvalidAmount(true);
					setFullWithdraw(false);
				} else if (Number(val) < minimumWithdrawAmount) {
					fieldForm.apiErrorMessage = `Minimum jumlah penarikan dana adalah ${rupiahCurrencyFormatter(
						minimumWithdrawAmount
					)}`;
					setInvalidAmount(true);
					setFullWithdraw(false);
				} else if (
					Number(val) === lenderSummary.cashBalance &&
					lenderSummary.cashBalance >= minimumWithdrawAmount
				) {
					fieldForm.apiErrorMessage = '';
					setInvalidAmount(false);
					setFullWithdraw(true);
				} else {
					fieldForm.apiErrorMessage = '';
					const payload: GetWithdrawFeePayload = {
						amount: Number(val),
						bankCode: user.bankInformation.bankCode,
						payment_method: user.bankInformation.methodPayment,
					};
					setAmountWithdraw(Number(val));
					dispatch(getWithdrawFeeAction(payload));
					setInvalidAmount(false);
					setFullWithdraw(false);
				}
			} else {
				fieldForm.apiErrorMessage = '';
				setInvalidAmount(true);
				setFullWithdraw(false);
			}
		} else if (fieldForm?.id === 'reason') {
			fieldForm.value = event.value;
		}
		const updateForm = [...form];
		setForm(updateForm);
	}

	function authFormOnChangeHandle(event: Record<string, string>): void {
		const fieldForm = authForm.find((field) => field.name === event.name);
		if (fieldForm?.id === 'password') {
			fieldForm.apiErrorMessage = error;
			fieldForm.value = event.value;
			if (event.value.length > 3) {
				setInvalidPassword(false);
				fieldForm.apiErrorMessage = '';
			} else {
				setInvalidPassword(true);
				fieldForm.apiErrorMessage = 'Minimum password 3 karakter';
			}
		}
	}

	function withdrawFormOnSubmit(event: FormEvent): void {
		event.preventDefault();
		const { bankInformation } = user;
		const val = String(form[0].value).split('.').join('');
		const payload: ISubmitWithdrawPayload = {
			accountName: bankInformation.bankAccountPayroll,
			accountNumber: bankInformation.bankAccount,
			amount: Number(val),
			bankCode: bankInformation.bankCode,
			password: String(authForm[0].value),
			reason: String(form[3].value),
			methodPayment: bankInformation.methodPayment || 0,
		};
		dispatch(submitWithdrawAction(payload));
	}

	function closeAuthForm(): void {
		authForm[0].value = '';
		authForm[0].apiErrorMessage = '';
		dispatch(resetWithdrawErrorStateAction(''));
		showAuthForm(false);
	}

	function renderHeaderModal(): ReactElement {
		return (
			<div className="titleContainer">
				<h3>Tarik Dana</h3>
				<button
					disabled={withdrawLoading}
					className="imageContainer btn"
					type="button"
					onClick={() => closeModal()}
				>
					<img src={ImagePath.close.src} alt={ImagePath.close.alt} />
				</button>
			</div>
		);
	}

	function renderCashBalance(): ReactElement {
		return (
			<div className="cash-balance-container">
				{!summaryLoading ? (
					<TextLabel
						bg
						title="Cash Balance"
						value={rupiahCurrencyFormatter(
							lenderSummary.cashBalance
						)}
						key="cash-balance"
					/>
				) : (
					<ShimmeringLoading />
				)}
			</div>
		);
	}

	function renderWithdrawToggle(): ReactElement {
		return (
			<div className="d-flex toggle-wrapper">
				<Toggle
					disabled={withdrawLoading || summaryLoading}
					checked={isFullWithdraw}
					icons={false}
					onChange={(event) => onToggleChange(event.target.checked)}
				/>
				<span>Tarik Semua</span>
			</div>
		);
	}

	function renderWithdrawForm(): ReactElement {
		return (
			<div>
				<form>
					{form.map((each) => (
						<div>
							<InputComponent
								disabled={each.disabled || withdrawLoading}
								key={each.id}
								id={each.id}
								formType={each.formType}
								placeholder={each.placeholder}
								name={each.name}
								apiErrorMessage={each.apiErrorMessage}
								value={renderValue(each)}
								options={each.options}
								onChange={(event) => {
									onChangeHandle(event);
								}}
							/>
							{each.id === 'biayaAdmin' && renderSpan()}
						</div>
					))}
				</form>
			</div>
		);
	}

	function renderSpan() {
		if (withdrawState.transfer_type !== 'IM') {
			return (
				<div className="fee-container">
					<img
						src={ImagePath.blueInfoIcon.src}
						alt={ImagePath.blueInfoIcon.alt}
					/>
					<span>
						Tipe Penarikan Dana:
						{' ' + maskingTransferType()}
					</span>
				</div>
			);
		}
		return null;
	}

	function maskingTransferType() {
		if (withdrawState.transfer_type === 'INTERBANK') {
			return 'Internal Transfer';
		}

		return withdrawState.transfer_type;
	}

	// eslint-disable-next-line  @typescript-eslint/no-explicit-any
	function renderValue(item: any) {
		switch (item.id) {
			case 'biayaAdmin':
				return thousandSeparator(withdrawState.transfer_fee);
			case 'fundsReceived':
				return thousandSeparator(
					amountWithdraw - withdrawState.transfer_fee
				);
			default:
				return item.value;
		}
	}

	function renderBankAccount(): ReactElement {
		const image =
			LocalStorageService.getUserData().bankInformation.bankUrlImage ||
			ImagePath.bankPlaceholder.src;
		return (
			<div>
				<h3>Akun Bank</h3>
				<div className="bank-info-container">
					<div className="bank-account">
						<img
							referrerPolicy="no-referrer"
							src={image}
							alt="bank"
						/>
						<hr />
						<div className="account-info">
							{bankAccountLabel.map((each) => (
								<div className="account" key={each.title}>
									<TextLabel
										bg={each.bg}
										title={each.title}
										value={each.value || '-'}
										color={each.color}
										ellipsis={each.ellipsis}
									/>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		);
	}

	function renderDisclaimer(): ReactElement {
		return (
			<div className="disclaimer-container">
				<img
					src={ImagePath.blueInfoIcon.src}
					alt={ImagePath.blueInfoIcon.alt}
				/>
				<span>Dana akan masuk maksimal 3 hari kerja</span>
			</div>
		);
	}

	function renderButton(): ReactElement {
		return (
			<button
				type="submit"
				className="btn btn-primary"
				disabled={invalid}
				onClick={() => showAuthForm(true)}
			>
				Tarik Dana
			</button>
		);
	}

	// -----Auth Form

	function renderHeaderAuthModal(): ReactElement {
		return (
			<div className="titleContainer">
				<h3>Masukan Kata Sandi</h3>
				<button
					disabled={withdrawLoading}
					className="imageContainer btn"
					type="button"
					onClick={() => closeAuthForm()}
				>
					<img src={ImagePath.close.src} alt={ImagePath.close.alt} />
				</button>
			</div>
		);
	}

	function renderAuthForm(): ReactElement {
		return (
			<div>
				<form onSubmit={(event) => withdrawFormOnSubmit(event)}>
					{authForm.map((each) => (
						<InputComponent
							disabled={withdrawLoading}
							key={each.id}
							id={each.id}
							formType={each.formType}
							placeholder={each.placeholder}
							name={each.name}
							apiErrorMessage={each.apiErrorMessage}
							value={each.value}
							options={each.options}
							onChange={(event) => {
								authFormOnChangeHandle(event);
							}}
						/>
					))}
					<div className="btn-container">
						<Button
							buttonText="Tarik Dana"
							disabled={withdrawLoading || invalidPassword}
							loading={withdrawLoading}
						/>
					</div>
				</form>
			</div>
		);
	}

	return (
		<div className="withdrawContainer">
			{!isAuthForm && (
				<>
					{renderHeaderModal()}
					{renderCashBalance()}
					{renderWithdrawToggle()}
					{renderWithdrawForm()}
					{renderBankAccount()}
					{renderDisclaimer()}
					{renderButton()}
				</>
			)}
			{isAuthForm && (
				<>
					{renderHeaderAuthModal()}
					{renderAuthForm()}
				</>
			)}
		</div>
	);
};

export default WithdrawModal;
